export const DEV = 'DEV';
export const PROD = 'PROD';
export const STAGE = 'STAGE';
